// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CardV1MedBenefitReplaceCardReplaceCardResponse {
    static getAttributeTypeMap() {
        return CardV1MedBenefitReplaceCardReplaceCardResponse.attributeTypeMap;
    }
}
CardV1MedBenefitReplaceCardReplaceCardResponse.discriminator = undefined;
CardV1MedBenefitReplaceCardReplaceCardResponse.additionalProperties = false;
CardV1MedBenefitReplaceCardReplaceCardResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "ExtCardMedBenCardReplaceResultModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=cardV1MedBenefitReplaceCardReplaceCardResponse.js.map